import * as elog from '@reverbdotcom/commons/src/elog';
import { FetchPolicy } from 'apollo-client';

export const FavoriteCacheTypes = {
  Listing: 'Listing',
  Search: 'Search',
  Shop: 'Shop',
} as const;
export type FavoriteCacheType = keyof typeof FavoriteCacheTypes;

const favoriteCacheKey = (type: FavoriteCacheType) => `favorites__cache_state__${type}`;
const staleValue = 'stale';

/**
 * Sets data in local storage to indicate that apollo cache data related to a
 * favorites hub query component is stale, and should be fetched remotely
 * next time that favorites hub page is loaded.
 */
export function setFavoritesCacheStale(type: FavoriteCacheType): void {
  const key = favoriteCacheKey(type);
  try {
    localStorage.setItem(key, staleValue);
  } catch (error) {
    elog.error('localStorage.setItem', {}, error);
  }
}

/**
 * Destructively checks if the favorites cache is stale (by checking, it resets to 'not stale').
 */
export function isFavoritesCacheStale(type: FavoriteCacheType): boolean {
  const key = favoriteCacheKey(type);

  let value;
  try {
    value = localStorage.getItem(key);
  } catch (error) {
    elog.error('localStorage.getItem', {}, error);
    value = staleValue;
  }

  try {
    localStorage.removeItem(key);
  } catch (error) {
    elog.error('localStorage.removeItem', {}, error);
  }

  return value === staleValue;
}

export function favoritesFetchPolicy(type: FavoriteCacheType): FetchPolicy {
  return isFavoritesCacheStale(type) ? 'network-only' : 'cache-first';
}
